import React, { FC } from 'react'
import { Stack, Text } from '@lojinha/design-system'
import { CopyButton } from '../../components/copy-button'

type Props = {
  title: string
  description: Array<{ text: string; isBold?: boolean }> | string
  code: string
  ariaLabelTitle?: string
  ariaLabelDescription?: string
  ariaLabelBtn: string
}

export const IndicationCode: FC<Props> = ({
  title,
  description,
  ariaLabelTitle,
  ariaLabelDescription,
  ariaLabelBtn,
  code,
}) => {
  return (
    <Stack layout="vertical" margin="x24">
      <Text
        isBrand
        textTransform="uppercase"
        textSize={['x3', 'x3', 'x4']}
        htmlAttrs={{
          'aria-hidden': !ariaLabelTitle,
          'aria-label': ariaLabelTitle,
        }}
      >
        {title}
      </Text>
      {typeof description === 'string' ? (
        <Text htmlAttrs={{ 'aria-label': ariaLabelDescription }}>
          {description}
        </Text>
      ) : (
        <Text
          htmlAttrs={{
            'aria-label': ariaLabelDescription,
          }}
        >
          {description.map(({ text, isBold }, index) =>
            isBold ? (
              <b key={index} style={{ fontWeight: 'bold' }}>
                {text}
              </b>
            ) : (
              text
            )
          )}
        </Text>
      )}
      <CopyButton ariaLabel={ariaLabelBtn} code={code} />
    </Stack>
  )
}
